<template>
<main>
  <section class="box" v-loading="loading" :element-loading-text="elementLoadingText">
    <div class="info">
      <header>
        <h3>{{hotel.Name_CN}}</h3>
        <i class="icon-dingweiweizhi">{{address}}</i>
        <figure>
          <h4>{{room.Name_CN}}</h4>
          <p>
            <i class="icon-yonghu">{{ Number(param.AdultCount) + Number(param.ChildCount) }}人</i>
            <i class="icon-WIFIwofi">{{room.HasWifi === 'True' ? '有' : '无'}}Wi-Fi</i>
            <i class="icon-chuanghu">{{room.HasWindow === 'True' ? '有' : '无'}}窗</i>
            <i class="icon-chuang">{{room.bed.Name_CN || '--'}}</i>
            <i class="icon-zaocan">{{room.hasFood ? '含' : '不含'}}餐</i>
          </p>
        </figure>
      </header>
      <div class="block">
        <div class="date">
          <p><span>入住日期</span><b>{{ param.CheckInDate | format('YYYY年MM月DD日')}}</b></p>
          <span>{{ param.CheckInDate | diffDay(param.CheckOutDate) }}晚</span>
          <p><span>退房日期</span><b>{{ param.CheckOutDate | format('YYYY年MM月DD日')}}</b></p>
        </div>
        <div class="check_in">
          <h4><b>入住信息</b><i class="icon-tishi">请按实际入住人数填写，姓名与证件保持一致</i></h4>
          <div class="option">
            <span>入住人</span>
            <div>
              <input v-model="submit.guest" type="text" placeholder="请输入入住人姓名" @change="changeName('guest')"/>
              <input class="small" v-model="submit.guestFirst" type="text" placeholder="姓，字母或拼音"/>
              <input class="small" v-model="submit.guestLast" type="text" placeholder="名，字母或拼音"/>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <h4><b>联系信息</b></h4>
        <div class="option">
          <span>联系人</span>
          <div>
            <input v-model="submit.contact" type="text" placeholder="请输入联系人姓名" @change="changeName('contact')"/>
            <input class="small" v-model="submit.contactFirst" type="text" placeholder="姓，字母或拼音"/>
            <input class="small" v-model="submit.contactLast" type="text" placeholder="名，字母或拼音"/>
          </div>
        </div>
        <div class="option">
          <span>手机号</span>
          <div>
            <input maxlength="11" v-model="submit.Phone" type="tel" placeholder="联系人手机号码"/>
          </div>
        </div>
        <div class="option">
          <span>邮箱</span>
          <div>
            <input v-model="submit.Email" type="tel" placeholder="联系人电子邮箱"/>
          </div>
        </div>
      </div>
    </div>
    <div class="r">
      <div class="block">
        <h4>费用明细</h4>
        <el-table :data="room.PriceList" border size="mini" class="table">
          <el-table-column prop="StayDate" label="日期">
            <template slot-scope="s">
              <span>{{s.row.StayDate | format('MM月DD日')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template slot-scope="s">
              <span>¥ {{s.row.Price}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block">
        <h4><span>退订规则</span><b v-if="room.canCancel === false">不可退订</b></h4>
        <el-table v-if="room.canCancel" :data="cancelList" border size="mini" class="table">
          <el-table-column prop="FromDate" label="日期"></el-table-column>
          <el-table-column label="取消及变更费用">
            <template slot-scope="s">
              <span :class="{green: s.row.Amount === 0}">{{ s.row.Amount > 0 ? '¥'+s.row.Amount : '免费取消' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pay">
        <figure>
          <span>应付总额：</span>
          <b>{{totalPrice}}</b>
        </figure>
        <el-button round type="primary" @click="goPay">去支付</el-button>
      </div>
    </div>
  </section>
</main>
</template>

<script>
import moment from 'moment';
import $py from '@assets/js/pinyin';
export default {
  data () {
    return {
      loading: true,
      elementLoadingText: null,
      param: {}, // 接受的传参
      info: {}, // 酒店信息
      // 房间信息
      room: {
        bed: {}
      },
      submit: {
        Phone: null,
        Email: null,
        contact: null,
        guest: null,
        contactFirst: null,
        contactLast: null,
        guestFirst: null,
        guestLast: null
      }
    }
  },
  filters: {
    format (date, format) {
      return moment(date).format(format);
    },
    diffDay (date1, date2) {
      return Math.abs(moment(date1).diff(date2, 'd'));
    }
  },
  computed: {
    cancelList () {
      const { RatePlanCancellationPolicyList: list = [] } = this.room;
      if (list.length === 0 ) { return []; }
      return [
        {
          Amount: 0,
          FromDate: list[0].FromDate+'前'
        },
        ...list
      ]
    },
    totalPrice () {
      const { PriceList = [] } = this.room;
      return PriceList.reduce((num, v) => {
        num += v.Price;
        return num;
      }, 0);
    },
    hotel () {
      const { hotelSummary = {} } = this.info;
      return hotelSummary;
    },
    address () {
      const { hotel = {} } = this;
      if (!hotel.CountryName_CN) { return '--'; }
      return `${ hotel.CountryName_CN } ${hotel.CityName_CN} ${hotel.DestinationName_CN} ${hotel.Address_CN}`;
    }
  },
  created () {
    const param = this.$route.query;
    this.param = param;
    this.getInfo();
  },
  methods: {
    changeName (attr) {
      const { first, last } = this.getPy(attr);
      const submit = { ...this.submit, [`${attr}First`]: first, [`${attr}Last`]: last, };
      this.submit = submit;
    },
    getPy (attr) {
      const py = $py(this.submit[attr]);
      const [ first ] = py[0];
      const last = py.reduce((txt, v, i) => {
        if ( i !== 0 ) { txt += v.join(''); }
        return txt;
      }, '');
      return { first, last };
    },
    getOrderData (ReferenceNo) {
      const { param, submit } = this;
      const { CheckInDate, CheckOutDate, ChildCount, AdultCount, HotelID, RoomTypeId } = param;
      const { Phone, Email, contact, guest, contactFirst, contactLast, guestFirst, guestLast } = submit;
      const data = {
        CheckOutDate,
        CheckInDate,
        NumOfRooms: 1,
        GuestList: [
            {
                "RoomNum": 1,
                "GuestInfo": [
                    {
                        "IsAdult": AdultCount > 0,
                        "Name": {
                            "name_cn": guest,
                            "Last": guestLast,
                            "First": guestFirst
                        }
                    }
                ]
            }
        ],
        "Contact": {
            "Name": {
                "name_cn": contact,
                "Last": contactLast,
                "First": contactFirst
            },
            Email,
            Phone
        },
        "ReferenceNo": ReferenceNo
      }
      return data;
    },
    getConfirmData () {
      const { CheckInDate, CheckOutDate, ChildCount, AdultCount, HotelID, RoomTypeId } = this.param;
      const { RatePlanID } = this.room;
      return {
        CheckInDate,
        CheckOutDate,
        HotelID: Number(HotelID),
        NumOfRooms: 1,
        OccupancyDetails: [{
          AdultCount: Number(AdultCount),
          ChildCount: Number(ChildCount),
          RoomNum: 1
        }],
        RatePlanID
      }
    },
    checkSubmit () {
      const { contactFirst, contactLast, guestFirst, guestLast, contact, guest, Phone, Email } = this.submit;
      const b = [contactFirst, contactLast, guestFirst, guestLast, contact, guest].every(v => !!v);
      if ( !b ) {
        this.$message.warning('联系人或入住人不能为空，请检查！');
        return false;
      }
      const tel = /^1[3-9]\d{9}$/;
      if ( tel.test(Phone) === false ) {
        this.$message.warning('手机号格式有误！');
        return false;
      }
      const emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if ( emailReg.test(Email) === false ) {
        this.$message.warning('电子邮箱格式有误！');
        return false;
      }
      return true;
    },
    async goPay () {
      if ( this.checkSubmit() === false ) { return; }
      this.loading = true;
      this.elementLoadingText = '正在生成订单...';
      const confirmData = this.getConfirmData();
      const { Success: { PriceDetails: { ReferenceNo } } } = await this.$axios.post('/didaApi/priceConfirm', confirmData );
      const data = this.getOrderData(ReferenceNo);
      const { OK: orderNo, is_pay } = await this.$axios.post('/hotelOrders/store', data);
      this.loading = false;
      this.$router.push({ name: 'hotel_order_pay', query: { orderNo } });
    },
    async getInfo () {
      const { HotelID, RatePlanID } = this.param;
      const info = await this.$axios.get('didaApi/hotelInfo?HotelID='+HotelID);
      const { didaBedTypeList } = await this.$axios.get('/didaApi/hotelBase');
      const bedType = JSON.parse(didaBedTypeList) || [];
      const { Success: { PriceDetails: { HotelList: [ { RatePlanList: list = [] } ] } } } = await this.$axios.get('/didaApi/hotelPriceSearch', { params: {...this.param, IsRealTime: 1} })
      const room = list.find(v => v.RatePlanID === RatePlanID);
      this.info = info;
      this.room = {
        ...room, 
        ...info.roomAttributes.find(sub => sub.RoomTypeID === room.RoomTypeID),
        hasFood: room.BreakfastType !== 1,
        canCancel: room.RatePlanCancellationPolicyList.filter(v => {
          const diff= moment().diff(moment(v.FromDate));
          return diff < 0;
        }).length > 0,
        bed: bedType.find(v => v.ID === room.BedType)
      };
      this.loading = false;
    }
  }
}
</script>

<style scoped src="./order_add.css"></style>